import { axiosService } from './AxiosService';

class AuthService {
    constructor() {
        this.user = null; // Stato utente, inizialmente non loggato
        this.axiosInstance = axiosService.getInstance(); // Usa l'istanza di AxiosService
    }

    // Metodo per eseguire il login
    async login(username, password) {
        try {
            const response = await this.axiosInstance.post('users/token', { username, password });
            if (response.status === 200) {
                this.user = response.data.data;
                localStorage.setItem('authToken', this.user.token);
                // Chiama il metodo updateToken dalla classe AxiosService
                axiosService.updateToken();  // Aggiorna il token dopo il login
                return this.user;
            } else {
                throw new Error('Login failed');
            }
        } catch (error) {
            console.error('Errore durante il login:', error);
            throw error;
        }
    }

    // Metodo per il logout
    logout() {
        this.user = null;
        localStorage.removeItem('authToken');
        // Aggiorna il token nelle intestazioni dopo il logout
        axiosService.updateToken();  // Rimuove il token dalle intestazioni
    }

    // Controlla se l'utente è loggato
    isLoggedIn() {
        return this.user?.id > 0;
    }

    // Ritorna il nome dell'utente
    getUserName() {
        return this.user ? this.user.first_name : null;
    }

    // Ritorna il tipo di utente
    getUserType() {
        return this.user ? this.user.role_id : null;
    }
}

export const authService = new AuthService();
